import { AttendanceInitialState } from "../../../types/hr/hrInterface";
import { HrActionTypes, HrActions } from "../../actionTypes/hr/hrActionTypes";

const initialState: AttendanceInitialState = {
  dailyAttendanceList: [],
  dailyAttendancePageCount: 0,
  myDailyAttendanceList: [],
  myDailyAttendancePageCount: 0,
  myRegularizationList: [],
  myRegularizationPageCount: 0,
  regularizationList: [],
  regularizationPageCount: 0,
  regularizationData: {
    id: null,
    employee_id: null,
    check_in: null,
    check_out: null,
    status: "",
    attendance_id: null,
    reason: "",
    remark: "",
    work_duration: null,
    createdAt: null,
    updatedAt: null,
    attendance_data: {
      id: null,
      user_id: null,
      check_in: null,
      check_out: null,
      total_work_duration: "00:00:00",
      overtime_hours: null,
      in_geo_location: null,
      out_geo_location: null,
      in_device_info: null,
      out_device_info: null,
      status: "-",
      is_late: false,
      approved: false,
      remarks: null,
    },
    user_application_data: {
      id: 0,
      name: "",
      user_code: "",
      branch: {
        id: 0,
        branch_code: "",
      },
    },
  },
  holidayList: [],
  holidayListPageCount: 0,
  holidayData: {
    id: 0,
    holiday_name: "",
    holiday_date: null,
    holiday_remark: "",
    createdAt: null,
    updatedAt: null,
  },
  isCheckedIn: false,
  isCheckedOut: false,
};

export default function attendanceReducer(state = initialState, action: HrActionTypes): AttendanceInitialState {
  switch (action.type) {
    case HrActions.SET_DAILY_ATTENDANCE_LIST:
      return {
        ...state,
        dailyAttendanceList: action.payload,
      };

    case HrActions.SET_MY_DAILY_ATTENDANCE_LIST:
      return {
        ...state,
        myDailyAttendanceList: action.payload,
      };

    case HrActions.SET_MY_REGULARIZATION_LIST:
      return {
        ...state,
        myRegularizationList: action.payload,
      };

    case HrActions.SET_REGULARIZATION_LIST:
      return {
        ...state,
        regularizationList: action.payload,
      };

    case HrActions.SET_DAILY_ATTENDANCE_PAGE_COUNT:
      return {
        ...state,
        dailyAttendancePageCount: action.payload,
      };

    case HrActions.SET_MY_DAILY_ATTENDANCE_PAGE_COUNT:
      return {
        ...state,
        myDailyAttendancePageCount: action.payload,
      };

    case HrActions.SET_MY_REGULARIZATION_PAGE_COUNT:
      return {
        ...state,
        myRegularizationPageCount: action.payload,
      };

    case HrActions.SET_REGULARIZATION_PAGE_COUNT:
      return {
        ...state,
        regularizationPageCount: action.payload,
      };

    case HrActions.SET_REGULARIZATION_DATA:
      return {
        ...state,
        regularizationData: action.payload,
      };

    case HrActions.SET_USER_CHECK_IN:
      return {
        ...state,
        isCheckedIn: action.payload,
      };

    case HrActions.SET_USER_CHECK_OUT:
      return {
        ...state,
        isCheckedOut: action.payload,
      };
    
    case HrActions.SET_HOLIDAY_LIST:
      return {
        ...state,
        holidayList: action.payload,
      };

    case HrActions.SET_HOLIDAY_LIST_PAGE_COUNT:
      return {
        ...state,
        holidayListPageCount: action.payload,
      };

    case HrActions.SET_HOLIDAY_DATA:
      return {
        ...state,
        holidayData: action.payload,
      };

    default:
      return state;
  }
}
